import { ChartSettings, ResourceExplorerData } from "@/services/cloudchipr.api";

export const resourceExplorerDefaultData: ResourceExplorerData = {
  date_label: "past_fourteen_days",
  grouping: "service",
  data_point: "daily",
  from_date: null,
  to_date: null,
  forecast_option: "month",
  dates: { label: "past_fourteen_days" },
  trend_type: "month_over_month",
  cost_type: "unblended",
};

export const billingExplorerDefaultChartSettings: ChartSettings = {
  series: 10,
  scale: "linear",
  show_legends: true,
  show_data_labels: true,
  display_forecast: false,
  cumulative_line: false,
  show_budget_line: false,
  show_trendline: false,
};

export const resourceExplorerChartDataOthersKey = "Others";
